import {Axios} from "axios";
import {z} from "zod";

export const createOrderRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
    ticketId: z.number(),
    rawOrderAnswers: z.array(
      z.object({
        questionId: z.number(),
        answer: z.string(),
      })
    ),
    cancelUrl: z.string(),
  }),
});
export type CreateOrderRequestPayload = z.infer<
  typeof createOrderRequestSchema
>;

export type CreateOrderApiResponse = {
  data: {
    stripeCheckoutLink: string;
  };
  message: string;
};

export type CreateOrderReponseData = {
  stripeCheckoutLink: string;
};

export async function createOrder(
  requestPayload: CreateOrderRequestPayload,
  axiosInstance: Axios
): Promise<CreateOrderReponseData> {
  createOrderRequestSchema.parse(requestPayload);
  const response = await axiosInstance.post(
    `event/${requestPayload.data.eventId}/order/checkout`,
    requestPayload.data
  );

  return response.data.data;
}
